type FlexSpacerProps = {
  className?: string;
  flex?: number;
};

export function FlexSpacer({
  className,
  flex = 1,
}: FlexSpacerProps): JSX.Element {
  return <div className={className ?? ''} style={{ flex }} />;
}
